import React from "react";
import {
  Tooltip,
  Button,
  Popover,
  DialogContent,
  DialogActions,
  CircularProgress,
} from "@material-ui/core";
import styled from "styled-components";
import ExtjsCodeMirror from "app/common/components/input/ExtjsCodeMirror";

export default function CodeSnippetPopup({
  anchorEl,
  onClose,
  onSave,
  formula: savedFormula = "",
  columnName,
  columnAliasNames,
  validateCodeSnippet,
  columnTypeId,
}) {
  const [formula, setFormula] = React.useState(savedFormula);
  const [isValidating, setValidating] = React.useState(false);

  const handleTestSyntaxClick = async () => {
    setValidating(true);
    await validateCodeSnippet(formula);
    setValidating(false);
  };

  const sampleExample = `
  1. amount = price * quantity;
  2. var t = 0;
  for(var i = 0; i < subsheet.length; i++) {   
    t = t + subsheet[i].price;
  }
  amount = t;
`;

  return (
    <Popover
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      open={Boolean(anchorEl)}
      onClose={onClose}
      anchorEl={anchorEl}
    >
      <DialogContent>
        Enter formula or code snippet.
        <SampleExampleTooltip
          title={
            <PreStyled>
              <code>{sampleExample}</code>
            </PreStyled>
          }
        >
          <Button component="a">Sample Example</Button>
        </SampleExampleTooltip>
        <ExtjsCodeMirror
          formula={savedFormula}
          onChange={setFormula}
          columnName={columnName}
          columnTypeId={columnTypeId}
        />
        <TestSyntaxButton variant="outlined" onClick={handleTestSyntaxClick}>
          {isValidating ? <CircularProgress size={18} /> : "Test Syntax"}
        </TestSyntaxButton>
        Available variables
        <AvailableVariables>
          {columnAliasNames.map((item) => (
            <React.Fragment>{item}, </React.Fragment>
          ))}
        </AvailableVariables>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={() => onSave(formula)}
          color="primary"
        >
          Save
        </Button>
      </DialogActions>
    </Popover>
  );
}

const PreStyled = styled.pre`
  color: white;
`;

const SampleExampleTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ tooltip: className }} />
))`
  && {
    max-width: 350px;
  }
`;

const AvailableVariables = styled.div`
  max-width: 350px;
  max-height: 300px;
  overflow: auto;
`;

const TestSyntaxButton = styled(Button)`
  && {
    display: block;
    margin: 5px;
  }
`;
